import React, { useEffect, useState } from "react";
import InlineSearchComponent from "../../../Components/Forms/InlineSearchComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useConfirm } from "material-ui-confirm";
import { useSnackbar } from "notistack";
import { UsuarioOperacao } from "../../../Models/Cadastros/Usuario/UsuarioOperacao";
import { UsuarioOperacaoService } from "../../../Services/Cadastros/Usuario/UsuarioOperacaoService";
import DataGridCrudComponent from "../../../Components/Forms/DataGridCrudComponent";

const UsuarioOperacaoTab = (props: any) => {
    const [usuarioOperacao, setUsuarioOperacao] = useState<any>(new UsuarioOperacao());
    const [usuarioOperacoes, setUsuarioOperacoes] = useState<any[]>([]);
    const confirm = useConfirm();
    const { enqueueSnackbar } = useSnackbar();
    const usuarioOperacaoService = new UsuarioOperacaoService()

    const usuarioOperacaoColunas: GridColDef[] = [
        { field: 'operacao_nome', headerName: 'Operação', minWidth: 200, flex: 0.2, },
        { field: 'operacao_permissao_grupo_nome', headerName: 'Grupo', minWidth: 200, flex: 0.2, },
    ];

    useEffect(() => {
        if (props.usuario == null) {
            return;
        }

        loadDados();
    }, [props.usuario]);

    function loadDados() {
        props.usuario.usuario_operacoes = props.usuario.usuario_operacoes ?? [];
        setUsuarioOperacoes(usuarioOperacaoService.selecionarValidos(props.usuario.usuario_operacoes));
    }

    function adicionar() {
        let response = usuarioOperacaoService.salvar(usuarioOperacao, props.usuario.usuario_operacoes);
        if (!response.valid) {
            enqueueSnackbar(response.message, {variant: 'error'});
            return;
        }

        props.usuario.usuario_operacoes = response.entities;
        loadDados();
        cancelar();
        enqueueSnackbar('Operação inserida com sucesso!', {variant: 'success'});
    }

    async function apagar(id: any) {
        await confirm({ title: "Deseja realmente apagar este registro?" });

        let response = usuarioOperacaoService.apagar(id, props.usuario.usuario_operacoes);
        if (!response.valid) {
            enqueueSnackbar(response.message, {variant: 'error'});
            return;
        }

        props.usuario.usuario_operacoes = response.entities;
        loadDados();
        enqueueSnackbar('Operação apagada com sucesso!', {variant: 'success'});
    }

    function cancelar() {
        setUsuarioOperacao(new UsuarioOperacao());
    }

    return (
        <div>
            <DataGridCrudComponent
                model={usuarioOperacao}
                save={adicionar}
                cancel={cancelar}
                labelSave='Adicionar'
                gridDelete={apagar}
                gridRows={usuarioOperacoes}
                gridColumns={usuarioOperacaoColunas}
                minWidthGridActionsArea={130}
                gridHideFooter={true}
                gridHideEdit={true}
                gridFieldId='id'
                gridHeight={500}>
                <div className="col-md-4 mb-3">
                    <InlineSearchComponent
                        id='combo_operacao'
                        label='Operação'
                        urlApi='buscaOperacoes'
                        valueField='id'
                        textField='nome_completo'
                        model={usuarioOperacao}
                        modelField='operacao_id'
                        modelFieldName='operacao_nome' />
                </div>
                
                <div className="col-md-4 mb-3">
                    <InlineSearchComponent
                        id='combo_operacao_permissao_grupo'
                        label='Operação Grupo'
                        urlApi='buscaOperacaoGrupos'
                        valueField='id'
                        textField='nome'
                        model={usuarioOperacao}
                        modelField='operacao_permissao_grupo_id'
                        modelFieldName='operacao_permissao_grupo_nome' />
                </div>
            </DataGridCrudComponent>
        </div>
    );
}

export default UsuarioOperacaoTab;